import React from 'react';
import { AssistantProfilesProvider } from './AssistantProfilesContext';
import AssistantProfilesPage from './AssistantProfilesPage';

export default function AssistantProfilesArea() {
  return (
    <AssistantProfilesProvider>
      <AssistantProfilesPage />
    </AssistantProfilesProvider>
  );
}
